import React from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomSelect = styled(Select)(({ theme }) => ({
  minWidth: "187px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CED4DA",
    borderRadius: "8px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CED4DA",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CED4DA",
  },
  ".MuiSelect-select": {
    padding: "8.5px",
    backgroundColor: "white",
    fontFamily: "DM Sans",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "29.41px",
    letterSpacing: "0px",
  },
}));

const CustomMenuItem = styled(MenuItem)({
  fontFamily: "DM Sans",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "29.41px",
  letterSpacing: "0px",
  "&:hover": {
    backgroundColor: "#EFE9FE",
  },
  "&.Mui-selected": {
    backgroundColor: "#EFE9FE",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#EFE9FE",
  },
});

const RowsPerPageDropdown = ({ onChange, value }) => {
  const options = [10, 50, 100];

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl variant="outlined" size="small">
      <CustomSelect
        value={value}
        onChange={handleChange}
        renderValue={(selectedValue) => `Show ${selectedValue} Users`}
        MenuProps={{
          PaperProps: {
            sx: {
              width: 190,
              borderRadius: "8px",
              padding: "16px 8px 16px 8px",
              "& .MuiList-root": {
                gap: "8px",
                display: "flex",
                flexDirection: "column",
                padding: 0,
              },
              boxShadow: "0px 0px 14px 0px #00000040",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            },
          },
        }}
      >
        {options.map((option) => (
          <CustomMenuItem key={option} value={option}>
            {option} Users
          </CustomMenuItem>
        ))}
      </CustomSelect>
    </FormControl>
  );
};

export default RowsPerPageDropdown;
